import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard, Server, Receipt, LifeBuoy, LogOut, Terminal,
} from "lucide-react";
import { Button } from "@/components/ui/button";

const nav = [
  { to: "/dashboard", label: "Visão geral", icon: LayoutDashboard, end: true, tid: "sidebar-overview" },
  { to: "/dashboard/vps", label: "Minhas VPS", icon: Server, tid: "sidebar-vps" },
  { to: "/dashboard/invoices", label: "Faturas", icon: Receipt, tid: "sidebar-invoices" },
  { to: "/dashboard/tickets", label: "Suporte", icon: LifeBuoy, tid: "sidebar-tickets" },
];

export default function ClientLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-[#09090B] text-zinc-100">
      <aside className="w-64 shrink-0 border-r border-white/10 flex flex-col">
        <div className="p-5 border-b border-white/10">
          <Link to="/" className="flex items-center gap-2" data-testid="sidebar-logo">
            <div className="h-8 w-8 flex items-center justify-center border border-white/20">
              <Terminal className="h-4 w-4" strokeWidth={2} />
            </div>
            <div>
              <div className="font-heading font-black tracking-tighter">Flix VPS</div>
              <div className="text-[10px] font-mono text-zinc-500 uppercase tracking-widest">Cliente</div>
            </div>
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {nav.map(({ to, label, icon: Icon, end, tid }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={tid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 text-sm rounded-sm border ${
                  isActive
                    ? "bg-white text-black border-white"
                    : "border-transparent text-zinc-400 hover:text-white hover:border-white/10 hover:bg-white/5"
                }`
              }
            >
              <Icon className="h-4 w-4" strokeWidth={2} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <div className="px-3 py-2 mb-2">
            <div className="text-xs text-zinc-500 font-mono uppercase tracking-widest">Usuário</div>
            <div className="text-sm font-medium truncate" data-testid="sidebar-user-name">{user?.name}</div>
            <div className="text-xs text-zinc-500 truncate font-mono">{user?.email}</div>
          </div>
          {user?.role === "admin" && (
            <Button
              variant="outline"
              className="w-full rounded-sm border-white/20 hover:bg-white hover:text-black mb-2"
              onClick={() => navigate("/admin")}
              data-testid="go-admin-btn"
            >
              Painel Admin
            </Button>
          )}
          <Button
            variant="ghost"
            className="w-full justify-start rounded-sm text-zinc-400 hover:text-white hover:bg-white/5"
            onClick={async () => { await logout(); navigate("/"); }}
            data-testid="logout-btn"
          >
            <LogOut className="h-4 w-4 mr-2" /> Sair
          </Button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <div className="max-w-6xl mx-auto p-6 sm:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
